import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, CARD_SIZE, Divider, Chips, CHIPS_COLOR, Link } from 'veloe-ds';
import './pedidoConcluido.scss';
import { modalTarifas } from '../../Components/Modais';
import { APP_PAGES } from '../../routes';
import { PERCENTAGE_MINIUM_RECHARGE } from '../../utils/recharge';
import {
  eventTrackEcommerce,
  eventTrackRoute,
} from '../../utils/pushDataLayer.js';

import { modalPlanoSemMensalidade } from '../../Components/Modais';
import {
  rateCalculation,
  finalBalanceCalculation,
} from '../../Components/RechargeRate';

/**
 * Exibe as informações de produto adquirido, pagamento, de cadastro do cliente e permite criar a senha
 *
 * */
class PedidoConcluido extends Component {
  constructor(props) {
    super(props);
    this.state = { novoEmail: '' };
  }

  componentDidMount = () => {
    const { history } = this.props;
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }
    eventTrackEcommerce(this.props.pedido, proposta, ['purchase', undefined]);
    eventTrackRoute('pedido-concluido');
    localStorage.clear();
    localStorage.setItem('propostaFinalizada', true);
  };

  changeEmail = (event) => {
    this.setState({ novoEmail: event });
  };

  render() {
    const {
      listaDeProdutos,
      dadosUsuario,
      tipoPagamento,
      dadosEndereco,
      ondeUsar,
      valorRecarga,
      totalProdutos,
      receberAdesivo,
    } = this.props.pedido;

    return (
      <div className="containerComponentDark">
        <div className="containerText">
          <div className="containerLabel">
            <div className="containerImg">
              <img src={require('../../assets/logo2x.png')} alt="" />
            </div>
          </div>
        </div>
        <div className="containerArea">
          <div className="containerPedidoConcluido">
            <div className="containerDescPedidoConcluido">
              <h1 className="titulo-pedido-concluido">
                Pedido feito com sucesso!
              </h1>

              {receberAdesivo !== 'nao' && (
                <label className="previsao">
                  Você vai receber seu adesivo ou pulseira em até
                  <b> 5 dias úteis.</b>
                </label>
              )}

              <div className="spacer" />
              <label data-testid="mensagem-envio-email">
                Enviamos para o e-mail <b>{dadosUsuario.email}</b> o link para
                fazer seu primeiro acesso.
              </label>
              <div className="spacer" />
            </div>
            <Card {...{ size: CARD_SIZE.LARGE }}>
              <div className="containerCardReviseCompra">
                <div className="containerTextReviseCompra">
                  <h1 className="tituloCardReviseCompra titulo-resumo" data-testid="titulo-resumo-pedido">
                    Resumo do pedido
                  </h1>

                  <Divider type="full" onBg="light" />

                  {listaDeProdutos.map((produto) => {
                    return (
                      <React.Fragment key={produto.id}>
                        <label className="tituloDestaqueReviseCompra titulo-produto">
                          <b>{produto.titulo}</b>
                        </label>

                        <div className="valoresReviseSuaCompra">
                          <label className="tituloReviseCompra" data-testid="titulo-produto-quantidade">
                            Quantidade
                          </label>
                          <label className="valorRevisaoPedido quantidade">
                            <b>{produto.quantidade}</b>
                          </label>
                        </div>

                        {ondeUsar.subProdutoId !== '001' && (
                          <div className="valoresReviseSuaCompra">
                            <label className="tituloReviseCompra">Valor</label>

                            <div className="containerValoresProdutos">
                              <label className="valorRevisaoPedido valor">
                                <b>
                                  R${' '}
                                  {produto.valor.toFixed(2).replace('.', ',')}
                                </b>
                              </label>
                            </div>
                          </div>
                        )}

                        <div className="valoresReviseSuaCompra">
                          <label className="tituloReviseCompra" data-testid="titulo-produto-onde-usar">
                            Onde usar
                          </label>
                          <label className="valorRevisaoPedido onde-usar">
                            <b>
                              {ondeUsar.subProdutoId !== '001'
                                ? ondeUsar.texto
                                : 'Pedágios/Estacionamentos'}
                            </b>
                          </label>
                        </div>

                        <Divider type="full" onBg="light" />
                      </React.Fragment>
                    );
                  })}

                  <label className="tituloDestaqueReviseCompra">
                    {ondeUsar.subProdutoId !== '001'
                      ? 'Mensalidade'
                      : 'Recarga'}
                  </label>

                  <div className="valoresReviseSuaCompra">
                    <label className="tituloReviseCompra" data-testid="titulo-tipo-pagamento">
                      Tipo de pagamento
                    </label>
                    <label className="valorRevisaoPedido tipo-pagamento">
                      <b>
                        {tipoPagamento === 'pos-pago'
                          ? 'Pós pago'
                          : ondeUsar.subProdutoId !== '001'
                          ? 'Recarga automática'
                          : 'Recarga manual'}
                      </b>
                    </label>
                  </div>

                  <div className="valoresReviseSuaCompra">
                    <label className="tituloReviseCompra" data-testid="titulo-recarga">
                      Recarga
                    </label>
                    <label className="valorRevisaoPedido tipo-pagamento">
                      <b>R$ {valorRecarga},00</b>
                    </label>
                  </div>
                  {tipoPagamento === 'recarga-automatica' && (
                    <div className="valoresReviseSuaCompra">
                      <label className="infoRecarga">
                        Sempre que seu saldo estiver inferior a R$
                        {(PERCENTAGE_MINIUM_RECHARGE / 100) * valorRecarga}, uma
                        nova recarga é realizada.
                      </label>
                    </div>
                  )}

                  {ondeUsar.subProdutoId !== '001' && (
                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Valor</label>
                      <div className="containerValoresMensalidade">
                        {ondeUsar.temMensalidade ? (
                          <Chips
                            {...{
                              color: CHIPS_COLOR.INFO,
                              label: ondeUsar.textoDesconto,
                              id: 'chips-desconto',
                            }}
                          />
                        ) : null}
                        <label className="valorRevisaoPedido tem-mensalidade">
                          {ondeUsar.valor}
                        </label>
                        <div className="textoPequeno">
                          {modalTarifas(
                            ondeUsar.mesesBonificacao,
                            ondeUsar.valorTarifa,
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {ondeUsar.subProdutoId === '001' && (
                    <>
                      <Divider type="full" onBg="light" />
                      <div className="valoresReviseSuaCompra">
                        <label className="tituloReviseCompra">Tarifa</label>
                        <label className="valorRevisaoPedido tipo-pagamento">
                          <b>- R$ {rateCalculation(valorRecarga)}</b>
                        </label>
                      </div>

                      <div className="valoresReviseSuaCompra">
                        <label className="tituloReviseCompra">
                          Será descontado do valor de sua recarga.
                        </label>
                      </div>

                      <div className="valoresReviseSuaCompra">
                        {modalPlanoSemMensalidade(true)}
                      </div>
                    </>
                  )}

                  <>
                    <Divider type="full" onBg="light" />

                    <label className="tituloDestaqueReviseCompra dados-pessoais">
                      Dados pessoais
                    </label>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">E-mail</label>
                      <label className="valorRevisaoPedido e-mail">
                        <b>{dadosUsuario.email}</b>
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Nome</label>
                      <label className="valorRevisaoPedido nome-usuario">
                        <b>{dadosUsuario.nomeCompleto}</b>
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">CPF</label>
                      <label className="valorRevisaoPedido cpf-usuario">
                        <b>{dadosUsuario.cpf}</b>
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Celular</label>
                      <label className="valorRevisaoPedido celular-usuario">
                        <b>{dadosUsuario.celular}</b>
                      </label>
                    </div>

                    <div className="valoresReviseSuaCompra">
                      <label className="tituloReviseCompra">Endereço</label>
                      <label className="valorRevisaoPedido endereco-usuario">
                        <b>
                          {dadosEndereco.endereco}, {dadosEndereco.numero},{' '}
                          {dadosEndereco.complemento
                            ? `${dadosEndereco.complemento}, `
                            : ''}
                          {dadosEndereco.bairro}
                          <br />
                          {dadosEndereco.cidade}-{dadosEndereco.estado}
                        </b>
                      </label>
                    </div>
                  </>

                  <Divider type="full" onBg="light" />

                  <div className="valoresReviseSuaCompra">
                    <h3>Total</h3>
                    <h2 className="total">
                      <b>
                        R$
                        {(totalProdutos?.valorTotalProdutos + valorRecarga)
                          .toFixed(2)
                          .replace('.', ',')}
                      </b>
                    </h2>
                  </div>

                  <div className="valoresReviseSuaCompra">
                    <label className="tituloReviseCompra lbl-frete">
                      Frete
                    </label>
                    <label className="valorRevisaoPedido lbl-gratis">
                      <b>Grátis</b>
                    </label>
                  </div>

                  {ondeUsar.subProdutoId === '001' && (
                    <>
                      <Divider type="full" onBg="light" />
                      <div className="valoresReviseSuaCompra">
                        <label className="tituloReviseCompra">
                          Saldo final para uso
                        </label>
                        <label className="valorRevisaoPedido tipo-pagamento">
                          <b>R$ {finalBalanceCalculation(valorRecarga)}</b>
                        </label>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Card>
            <div className="pedidoConcluidoFooter">
              <Link
                {...{
                  color: 'primary',
                  onBg: 'dark',
                  href: 'http://www.veloe.com.br',
                }}
              >
                {' '}
                Ir para home{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

export default connect(mapStateToProps)(PedidoConcluido);
